
export default {
  name: 'priceConfirmPop',
  data() {
    return {
      dialogVisible: false,
      feeList: [],
      confirmData: {},
      // 当前售价
      changePrice: '',
      // 服务费
      serviceFee: null,
      // 到手金额
      incomeMoney: null,
      // 心理底价
      changeBasePrice: '',
      // 心理底价服务费
      serviceFee2: null,
      // 心理底价到手金额
      incomeMoney2: null,
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    async openDialog(data) {
      this.confirmData = data
      // this.changePrice = data.topPrice
      // this.changeBasePrice = data.topBasePrice
      //费率计算
      try {
        const { gameId, goodsCatalogueId } = this.confirmData.topPriceGoods
        const par = {
          action: {
            gameId,
            goodsCatalogueId,
            goodsNo: this.$route.query.goodsNo
          }
        }
        const res = await this.$api.getFeeNew(par)

        if (!res.success) return this.$message.error(res.info)
        this.feeList = res.data
      } catch (err) {
        this.$message.error(err.message)
      }
      await this.onGetFee(this.changePrice, 'changePrice')
      await this.onGetFee(this.changeBasePrice, 'changeBasePrice')
      this.dialogVisible = true
    },
    async handleComplete() {
      if (!+this.changePrice) {
        return this.$message.error('请输入当前售价')
      }
      if (!+this.changeBasePrice) {
        return this.$message.error('请输入当前心里底价')
      }
      const par = {
        changePrice: this.changePrice,
        changeBasePrice: this.changeBasePrice,
        goodsNoList: this.confirmData.goodsNos,
        goodsUnionNo: this.confirmData.goodsUnionNo
      }
      let res = await this.$api.unionBindAPI(par)
      if (!res.success) {
        return this.$message.error(res.info)
      }
      this.handleClose()
      this.$emit('priceConfirm')
    },
    /**
     * 根据卖家报价获取对应服务费
     * @param {*} price
     */
    async onGetFee(price, field) {
      price = Number(price)
      if (!price) return
      const feeResult = []
      this.feeList.forEach(item => {
        const fee = {
          fee: 0,
          name: item.feeTypeName
        }
        const targetFee = item.fees.find(feeItem => feeItem.priceMin <= price && feeItem.priceMax > price)

        if (!targetFee) return

        if (targetFee.feeWay === 'FIXED') {
          // fee.name += '(固定)'
          fee.fee = targetFee.fee.toFixed(2)
        } else {
          // fee.name += `(费率${targetFee.fee}%)`
          fee.fee = (price * (targetFee.fee / 100)).toFixed(2)
        }

        if (Number(fee.fee) === 0) return
        feeResult.push(fee)
      })
      const serviceFee = feeResult.reduce((total, item) => total + Number(item.fee), 0).toFixed(2)
      const incomeMoney = (price - feeResult.reduce((total, item) => total + Number(item.fee), 0)).toFixed(2)

      if (field === 'changePrice') {
        this.serviceFee = serviceFee
        this.incomeMoney = incomeMoney
      } else {
        this.serviceFee2 = serviceFee
        this.incomeMoney2 = incomeMoney
      }
    },
    onPriceChange(val) {
      this.onGetFee(this.changePrice, 'changePrice')
    },
    onBasePriceChange(val) {
      this.onGetFee(this.changeBasePrice, 'changeBasePrice')
    }
  },
  mounted() {

  }
}
